'use client';

import { createContext, useContext, ReactNode } from 'react';

import { useFilterSync } from './useFilterSync';

// Интерфейс контекста синхронизации фильтров
interface FilterSyncContextType {
  isStickyVisible: boolean;
  setContentFilterRef: (element: HTMLElement | null) => void;
  setStickyHeaderRef: (element: HTMLElement | null) => void;
}

// Создаем контекст
const FilterSyncContext = createContext<FilterSyncContextType | undefined>(
  undefined
);

// Интерфейс для пропсов провайдера
interface FilterSyncProviderProps {
  children: ReactNode;
}

/**
 * Провайдер контекста синхронизации фильтров
 */
export function FilterSyncProvider({ children }: FilterSyncProviderProps) {
  const filterSync = useFilterSync();

  return (
    <FilterSyncContext.Provider value={filterSync}>
      {children}
    </FilterSyncContext.Provider>
  );
}

/**
 * Хук для доступа к контексту синхронизации фильтров
 */
export function useFilterSyncContext() {
  const context = useContext(FilterSyncContext);

  if (context === undefined) {
    throw new Error(
      'useFilterSyncContext must be used inside FilterSyncProvider'
    );
  }

  return context;
}
